import React from "react";
import { wrapCollectionLayout, EagerLoadImages } from "@quintype/components";
import TopStories from "./top-stories";
import SixStories from "./six-stories";
import SevenStories from "./seven-stories";
import SixStoyGrid from "./six-story-grid";
import SixTextStoryCards from "./six-text-story-cards";
import VideoCardSlider from "./video-slider";
import SingleCardSlider from "./single-card-slider";
import SingleBigCardSlider from "./single-big-card-slider";
import HoroscopeCollection from "./horoscope-collection";
import ThreeCardSlider from "./three-card-slider";
import ThreeColFourStories from "./three-col-four-stories";
import ThreeColFourStories2 from "./three-col-four-stories2";
import SliderWithMultipleBigCards from "./slider-with-multiple-big-cards";
import TwoCollectionWithTenStroies from "./two-collection-ten-stories";
import OpinionStories from "./opinion-stories";
import BillBoardCollectionAd from "./billboard-collection-ad";
import CollectionWidget from "./collection-widget";
import CollectionWidgetWithSearch from "./collection-widget-with-search";
import TwoStateElectionWidgetWithSearch from "./two-state-election-widget-with-search";
import ElectionWidgetWithSearch from "./election-widget-with-search";
import TopNews1 from "./top-news-1";
import TopNewsWithElectionWidget from "./top-news-1-election";
import TopNews2 from "./top-news-2";
import TopNews3 from "./top-news-3";
import Row18 from "./Row-18";
import Row18Budget from "./Row-18-budget";
import TwoColOneBigNineSmallCards from "./two-col-one-big-nine-small-cards";
import TopNewsWithBudget from "./top-news-1-budget";
import FourCardSlider from "./four-card-slider";
import ThreeColSixCollection from "./three-col-six-collection";
import CollectionWidgetTop from "./collection-widget-top";
import LiveNewsCollection from "./live-news-collection";
import LiveNewsCollectionSPCL from "./live-news-collection-spcl";
import LiveElectionCollection from "./live-news-collection-election";

// This should not be needed anymore as we are using Gumlet
function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    if (props.index === 0) {
      return (
        <EagerLoadImages predicate={(token) => token === "above-fold"}>{React.createElement(f, props)}</EagerLoadImages>
      );
    } else {
      return React.createElement(f, props);
    }
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  if (f.nestedCollectionLimit) {
    wrappedComponent.nestedCollectionLimit = f.nestedCollectionLimit;
  }

  return wrappedComponent;
}

export default {
  TopStories: wrapEager(wrapCollectionLayout(TopStories)),
  SixStories: wrapEager(wrapCollectionLayout(SixStories)),
  SevenStories: wrapEager(wrapCollectionLayout(SevenStories)),
  ThreeCardSlider: wrapEager(wrapCollectionLayout(ThreeCardSlider)),
  FourCardSlider: wrapEager(wrapCollectionLayout(FourCardSlider)),
  VideoCardSlider: wrapEager(wrapCollectionLayout(VideoCardSlider)),
  SixTextStoryCards: wrapEager(wrapCollectionLayout(SixTextStoryCards)),
  OpinionStories: wrapEager(wrapCollectionLayout(OpinionStories)),
  HoroscopeCollection: wrapEager(wrapCollectionLayout(HoroscopeCollection)),
  SingleCardSlider: wrapEager(wrapCollectionLayout(SingleCardSlider)),
  SingleBigCardSlider: wrapEager(wrapCollectionLayout(SingleBigCardSlider)),
  SliderWithMultipleBigCards: wrapEager(wrapCollectionLayout(SliderWithMultipleBigCards)),
  TwoCollectionWithTenStroies: wrapEager(wrapCollectionLayout(TwoCollectionWithTenStroies)),
  SixStoyGrid: wrapEager(wrapCollectionLayout(SixStoyGrid)),
  ThreeColFourStories: wrapEager(wrapCollectionLayout(ThreeColFourStories)),
  ThreeColSixCollection: wrapEager(wrapCollectionLayout(ThreeColSixCollection)),
  ThreeColFourStories2: wrapEager(wrapCollectionLayout(ThreeColFourStories2)),
  BillBoardCollectionAd: wrapEager(wrapCollectionLayout(BillBoardCollectionAd)),
  TwoColOneBigNineSmallCards: wrapEager(wrapCollectionLayout(TwoColOneBigNineSmallCards)),
  CollectionWidget: wrapEager(wrapCollectionLayout(CollectionWidget)),
  CollectionWidgetTop: wrapEager(wrapCollectionLayout(CollectionWidgetTop)),
  CollectionWidgetWithSearch: wrapEager(wrapCollectionLayout(CollectionWidgetWithSearch)),
  TwoStateElectionWidgetWithSearch: wrapEager(wrapCollectionLayout(TwoStateElectionWidgetWithSearch)),
  ElectionWidgetWithSearch: wrapEager(wrapCollectionLayout(ElectionWidgetWithSearch)),
  TopNews1: wrapEager(wrapCollectionLayout(TopNews1)),
  TopNewsWithElectionWidget: wrapEager(wrapCollectionLayout(TopNewsWithElectionWidget)),
  TopNewsWithBudget: wrapEager(wrapCollectionLayout(TopNewsWithBudget)),
  TopNews2: wrapEager(wrapCollectionLayout(TopNews2)),
  TopNews3: wrapEager(wrapCollectionLayout(TopNews3)),
  Row18: wrapEager(wrapCollectionLayout(Row18)),
  Row18Budget: wrapEager(wrapCollectionLayout(Row18Budget)),
  LiveNewsCollection: wrapEager(wrapCollectionLayout(LiveNewsCollection)),
  LiveNewsCollectionSPCL: wrapEager(wrapCollectionLayout(LiveNewsCollectionSPCL)),
  LiveElectionCollection: wrapEager(wrapCollectionLayout(LiveElectionCollection)),
  defaultTemplate: wrapEager(wrapCollectionLayout(TwoCollectionWithTenStroies))
};
